import { FilterElementProps } from './sort-filter-search';

export function updateCheckedFilter(existingFilters: FilterElementProps[], key: string, checked: boolean) {
  const changedFilter = existingFilters.find((filter) => filter.key === key);
  if (changedFilter) {
    changedFilter.checked = checked;
  }
  return existingFilters;
}
